// Build a windowed snippet from a doc text + the user's query,
// wrapping matched tokens in <mark>. Plain-text input, safe to inject.

import { tokenize } from "./loadIndex";

const ESCAPE = { "&": "&amp;", "<": "&lt;", ">": "&gt;" };
const escapeHtml = (s) => s.replace(/[&<>]/g, (c) => ESCAPE[c]);

const WORDS_BEFORE = 14;
const WORDS_AFTER = 28;

export function buildSnippet(text, query) {
  if (!text) return "";
  const safe = escapeHtml(String(text));

  const queryTokens = new Set(tokenize(query).map((t) => t.toLowerCase()));
  if (queryTokens.size === 0) {
    return safe.length > 280 ? `${safe.slice(0, 280).trimEnd()}…` : safe;
  }

  // Build a regex that matches any query token (whole-word, case-insensitive)
  const pattern = new RegExp(
    `\\b(${[...queryTokens].map(escapeRegex).join("|")})`,
    "gi",
  );

  // Window around the first match
  const words = safe.split(/(\s+)/);
  const firstHit = words.findIndex((w) => pattern.test(w));
  let start = 0;
  let end = Math.min(words.length, (WORDS_BEFORE + WORDS_AFTER) * 2);
  if (firstHit !== -1) {
    start = Math.max(0, firstHit - WORDS_BEFORE * 2);
    end = Math.min(words.length, firstHit + WORDS_AFTER * 2);
  }
  let window = words.slice(start, end).join("");
  if (start > 0) window = `…${window}`;
  if (end < words.length) window = `${window}…`;

  // Highlight matched tokens
  pattern.lastIndex = 0;
  return window.replace(pattern, "<mark>$1</mark>");
}

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
